export default __webpack_public_path__ + "static/media/whatsapp.2eeae83a.svg";